module.exports = __webpack_public_path__ + "images/emoji/white_check_mark.236c151ec4774ba5011b.png";